export default "__VITE_ASSET__606bc35d__"